import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    title: {
        color: theme.palette.secondary.main,
    },
    statusMessage: {
        color: theme.palette.secondary.main,
    },
    deleteButton: {
        color: theme.palette.secondary.main,
        padding: theme.spacing(1.25),
    },
    editButton: {
        color: theme.palette.secondary.main,
        padding: theme.spacing(1.25),
    },
    errorBanner: {
        display: "flex",
        alignItems: "center",
        marginTop: 0,
        padding: 0,
        borderRadius: theme.shape.borderRadius,
        gap: theme.spacing(3),
    },
    errorIcon: {
        width: 24,
        height: 24,
        fill: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        "& path": {
            fill: "currentColor",
        },
    },
    errorBannerText: {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.secondary.main,
    },
}));
